import type { RouteType } from '$lib/components/route/types';
import * as m from '$paraglide/messages';

const routeMarkers: Record<RouteType, () => string> = {
	economic: m.route__routemarkers__ariaLabel__economic,
	quickest: m.route__routemarkers__ariaLabel__quickest,
	ecological: m.route__routemarkers__ariaLabel__ecological,
	alternative: m.route__routemarkers__ariaLabel__alternative,
	shortest: m.route__routemarkers__ariaLabel__shortest,
	discovery: m.route__routemarkers__ariaLabel__discovery,
};

export function routeMarkersLabel(type: RouteType): string {
	return routeMarkers[type]();
}
